import { useQuery } from 'react-query'
import client from './api-client'

const queryConfig = {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
}

async function fetchSprayingWindow(parcel_id, uPrec, uMInfWind, uMSupWind, uHInfWind, uHSupWind, uTemp, modify) {
    const data = await client(`spraying_data/spraying_window/?parcel_id=${parcel_id}&uPrec=${uPrec}&uMInfWind=${uMInfWind}&uMSupWind=${uMSupWind}&uHInfWind=${uHInfWind}&uHSupWind=${uHSupWind}&uTemp=${uTemp}&modify=${modify}`)
    return data
}

export function useSprayingWindow(parcel_id, uPrec, uMInfWind, uMSupWind, uHInfWind, uHSupWind, uTemp, modify) {
    return useQuery(['spraying_window', parcel_id, uPrec, uMInfWind, uMSupWind, uHInfWind, uHSupWind, uTemp, modify], 
                    () => fetchSprayingWindow(parcel_id, uPrec, uMInfWind, uMSupWind, uHInfWind, uHSupWind, uTemp, modify), {
        refetchAllOnWindowFocus: false,
        ...queryConfig
    });
}